/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {useCallback} from 'react';
import {Platform, Text, TouchableOpacity, View} from 'react-native';
import Label from '../../../../components/Label';

import {useFocusEffect, useNavigation} from '@react-navigation/native';
import {connect} from 'react-redux';
import {VoyageServices} from '../../../../../services/applicatif/voyages';
import mapDispatchToProps from '../../../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../../../services/redux/mapStateToProps';
import {HeaderScreen} from '../../../../components/Header/HeaderScreen';
import {Loader} from '../../../../components/Loader';
import ConfirmationModal from '../../../../components/Modal/ConfirmationModal';

import {StackNavigationProp} from '@react-navigation/stack';
import dayjs from 'dayjs';
// import 'dayjs/locale/fr';
import {
  countPersonsInAgeRanges,
  defaultAgeRangeVoyage,
  generateUUID,
  getOldestDate,
} from '../../../../../common/utils/functions';
import {initModalData} from '../../../../../data/constants/Assurance/AssuranceVoyage/souscription';
import {mapAgence} from '../../../../../data/factory/agence';
import {ApiResponse} from '../../../../../data/types/interface/api';
import {
  NewDevisItem,
  SubmitDevisVoyage,
} from '../../../../../data/types/interface/Assurance/AssuranceVoyage/devis';
import {ModalDataDTO} from '../../../../../data/types/interface/Assurance/AssuranceVoyage/souscription';
import {StackParams} from '../../../../../data/types/navigation';
import {ButtonItems} from '../../../../components/AssuranceVoyage';
import {PageContainer} from '../../../../components/PageContainer';
import {Result} from '../Demande/Result';
import {styles} from './styles';

type NavigationProps = StackNavigationProp<
  StackParams,
  'DemanderDevisAssuranceVoyage'
>;
interface MesDevisFCProps {
  getAgence: any;
  user?: any;
}
const MesDevisFC = ({getAgence, user}: MesDevisFCProps) => {
  const {
    listDevis: getListDevis,
    postDevis,
    removeDevis,
    listCategories: getListCategory,
  } = VoyageServices();
  const {navigate} = useNavigation<NavigationProps>();

  const [resDevis, setResDevis] = React.useState<SubmitDevisVoyage | undefined>(
    undefined,
  );
  const [listDevis, setListDevis] = React.useState<Array<NewDevisItem>>([]);
  const [listCategory, setListCategory] = React.useState<Array<any>>([]);
  const [listAgence, setListAgence] = React.useState<Array<any>>([]);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [confirmation, setConfirmation] = React.useState<{
    status: boolean;
    message: string;
    type: 'suppression' | 'souscription' | 'modification' | undefined;
  }>({status: false, message: '', type: undefined});

  const [modalData, setModalData] = React.useState<ModalDataDTO>({
    ...initModalData,
  });

  useFocusEffect(
    useCallback(() => {
      if (!user?.data?.utilisateur) {
        navigate('Login', {
          data: 'ListDevisAssuranceVoyage',
        });
      }
    }, [user?.data?.utilisateur]),
  );

  const handleGetListCategory = async () => {
    setIsLoading(true);
    try {
      const res: ApiResponse = await getListCategory();
      if (!res?.isError) {
        setListCategory(res?.data || []);
      } else {
        setConfirmation({
          status: true,
          message:
            (typeof res?.details == 'string' ? res.details : res.message) || '',
          type: undefined,
        });
      }
    } catch (error) {
      console.log('error', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleGetListDevis = async () => {
    setIsLoading(true);
    try {
      const res = await getListDevis();
      if (!res?.isError && res?.data && Array.isArray(res.data)) {
        // ordorner la liste de devis dans l'ordre inverse
        setListDevis(
          [
            ...res.data
              .slice(0)
              .reverse()
              .map(elt => {
                return {
                  id: elt.id,
                  idCategory: elt.destinations.categorieId,
                  idDestination: elt.destinations.id,
                  dateDebut: new Date(elt.dateDebut),
                  dateFin: new Date(elt.dateFin),
                  dateNaissance: dayjs(new Date(elt.dateNaissance))
                    .startOf('day')
                    .format('YYYY-MM-DD'),
                  motif: elt.motif,
                  listNaissance: elt.listNaissance.map(n => ({
                    id: generateUUID(),
                    value: new Date(n),
                  })),
                  enfant: parseInt(elt.enfant),
                  adult: parseInt(elt.adult),
                  senior: parseInt(elt.senior),
                  category: {
                    code: elt.destinations.categorie,
                    label: elt.destinations.categorieLabel,
                  },
                  destination: {
                    code: elt.destinations.value,
                    label: elt.destinations.label,
                  },
                };
              }),
          ] || [],
        );
      } else {
        setConfirmation({
          status: true,
          message:
            (typeof res?.details == 'string' ? res.details : res.message) || '',
          type: undefined,
        });
      }
      getAgence({}, (res: any) => {
        if (res && !res.isError && res.data && res.data.items) {
          const _list = mapAgence(res.data.items);
          setListAgence([..._list]);
        }
      });
    } catch (error) {
      console.log('error', error);
    } finally {
      if (listCategory.length) {
        setIsLoading(false);
      } else {
        handleGetListCategory();
      }
    }
  };

  const goToDemanderDevisAssurance = useCallback((item: NewDevisItem) => {
    navigate('DemanderDevisAssuranceVoyage', {
      category: item.category.code,
      destination: item.destination.code,
      listNaissance: item.listNaissance,
      dateDebut: item.dateDebut,
      dateFin: item.dateFin,
      motif: item.motif ?? '',
    });
  }, []);

  const handlePostDevisDetails = async (
    item: NewDevisItem,
    toSouscription: boolean = false,
  ) => {
    const oldest = item.listNaissance.length
      ? getOldestDate(item.listNaissance.map(elt => elt.value))
      : item.dateNaissance;

    setIsLoading(true);

    try {
      if (dayjs(item.dateDebut).isAfter(new Date(), 'day')) {
        const res: ApiResponse = await postDevis({
          idCategory: item.idCategory,
          idDestination: item.idDestination,
          dateNaissance: dayjs(oldest).format('YYYY-MM-DD'),
          dateDebut: item.dateDebut,
          dateFin: item.dateFin,
          listNaissance: item.listNaissance,
        });
        if (
          !res?.isError &&
          res?.data &&
          toSouscription &&
          res.data.length === 1
        ) {
          navigate('SouscriptionAssuranceVoyage', {
            montant: res.data[0].montant,
            category: item.category.code,
            dateNaissance: item.dateNaissance,
            dateDebut: dayjs(item.dateDebut).format('YYYY-MM-DD'),
            dateFin: dayjs(item.dateFin).format('YYYY-MM-DD'),
            destination: item.destination.code,
            enfant: `${item.enfant}`,
            adult: `${item.adult}`,
            senior: `${item.senior}`,
            quoteCode: res.data[0].quoteCode,
            listNaissance: item.listNaissance,
            listCategory,
            listAgence,
          });
          setIsLoading(false);
        } else if (!res?.isError && res?.data && res.data.length) {
          setResDevis({
            categoryCode: item.category.code,
            categoryLabel: item.category.label,
            idCategory: item.idCategory,
            destinationCode: item.destination.code,
            destinationLabel: item.destination.label,
            idDestination: item.idDestination,
            dateNaissance: item.dateNaissance,
            listNaissance: item.listNaissance.length
              ? item.listNaissance
              : Array.from(
                  {
                    length:
                      Number(item.enfant) +
                      Number(item.adult) +
                      Number(item.senior),
                  },
                  () => ({id: generateUUID(), value: new Date()}),
                ),
            dateDebut: item.dateDebut,
            dateFin: item.dateFin,
            type: [
              ...res?.data.map((element: any) => ({
                montant: element.montant || '',
                quoteCode: element.quoteCode || '',
                type: element.type || '',
                destination: element.destination,
              })),
            ],
            motif: item.motif,
          });
          setIsLoading(false);
        } else {
          setIsLoading(false);
          setConfirmation({
            status: true,
            message: res?.message || '',
            type: 'souscription',
          });
        }
      } else {
        goToDemanderDevisAssurance(item);

        setIsLoading(false);
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  const handleRemoveDevisDetails = async (id: string) => {
    setModalData({...initModalData});
    setIsLoading(true);
    try {
      const res: any = await removeDevis(id);
      if (!res?.isError) {
        handleGetListDevis();
        setIsLoading(false);
      } else {
        setIsLoading(false);
        setConfirmation({
          status: true,
          message:
            (typeof res?.details == 'string' ? res.details : res.message) || '',
          type: undefined,
        });
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  useFocusEffect(
    React.useCallback(() => {
      if (user?.data?.utilisateur) {
        handleGetListDevis();
      }
      setResDevis(undefined);
    }, [user?.data?.utilisateur]),
  );

  const categorizeAge = useCallback(
    (devis: NewDevisItem) =>
      devis.listNaissance.length
        ? countPersonsInAgeRanges(
            devis.listNaissance.map(elt => ({value: elt})),
            defaultAgeRangeVoyage,
            'value',
          )
        : {
            childrens: Number(devis.enfant),
            adults: Number(devis.adult),
            seniors: Number(devis.senior),
          },
    [],
  );

  return (
    <View style={styles.container}>
      <HeaderScreen
        title="Mes Assurances Voyages"
        type="retour"
        noBreadcrumb={false}
      />
      {confirmation.status ? (
        <ConfirmationModal
          title="Attention"
          content={
            /365/.test(confirmation.message)
              ? "Veuillez modifier la date début de la couverture pour être supérieur a aujourd'hui!"
              : confirmation.message
          }
          btn1="OK"
          handleBtn1={() => {
            setConfirmation((prev: any) => ({
              ...prev,
              status: false,
            }));
          }}
        />
      ) : null}
      {modalData.status && (
        <ConfirmationModal
          title={modalData.title}
          content={modalData.content}
          btn1={modalData.btn1}
          btn2={modalData.btn2}
          handleBtn1={modalData.handleBtn1}
          handleBtn2={modalData.handleBtn2}
        />
      )}
      {isLoading ? (
        <Loader />
      ) : resDevis ? (
        <Result
          datas={resDevis}
          navigate={navigate}
          listCategory={listCategory}
          onCancel={() =>
            navigate('DemanderDevisAssuranceVoyage', {
              category: resDevis.categoryCode,
              destination: resDevis.destinationCode,
              dateDebut: resDevis.dateDebut,
              dateFin: resDevis.dateFin,
              listNaissance: resDevis.listNaissance || [],
              motif: resDevis.motif || '',
            })
          }
        />
      ) : (
        <PageContainer style={styles.scrollContainer}>
          {listDevis.length
            ? listDevis.map((devis, index: number) => {
                return (
                  <TouchableOpacity
                    key={`listContract_${index}`}
                    style={styles.itemContainer}
                    onPress={() => handlePostDevisDetails(devis)}>
                    <View style={{flexDirection: 'column', marginBottom: 10}}>
                      <Label
                        textStyle={{marginTop: 0}}
                        type="mainTitle"
                        title={devis.destination.label}
                      />
                      <View
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          rowGap: 6,
                          alignItems: 'flex-start',
                        }}>
                        <View
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            gap: 8,
                            flexWrap: 'wrap',
                          }}>
                          <Label
                            title={'Date de naissance du plus agée : '}
                            type="titleGreen14"
                          />
                          <Label
                            title={`${dayjs(
                              devis.dateNaissance,
                              'YYYY-MM-DD',
                            ).format('DD/MM/YYYY')}`}
                          />
                        </View>
                        <Text>
                          {devis.enfant > 0 ? (
                            <>
                              <Label title={`${devis.enfant}`} />
                              <Label
                                title={` enfant${devis.enfant > 1 ? 's' : ''} `}
                                type="titleGreen14"
                              />
                            </>
                          ) : null}
                          {devis.adult > 0 ? (
                            <>
                              <Label title={`${devis.adult}`} />
                              <Label
                                title={` adulte${devis.adult > 1 ? 's' : ''} `}
                                type="titleGreen14"
                              />
                            </>
                          ) : null}
                          {devis.senior ? (
                            <>
                              <Label title={`${devis.senior}`} />
                              <Label
                                title={` senior${devis.senior > 1 ? 's' : ''} `}
                                type="titleGreen14"
                              />
                            </>
                          ) : null}
                        </Text>
                        <View
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            gap: 8,
                          }}>
                          <Label title={'Voyage du '} type="titleGreen14" />
                          <Label
                            title={`${dayjs(devis.dateDebut).format(
                              'DD/MM/YYYY',
                            )}`}
                          />
                          <Label title={' au '} type="titleGreen14" />
                          <Label
                            title={`${dayjs(devis.dateFin).format(
                              'DD/MM/YYYY',
                            )}`}
                          />
                        </View>
                      </View>
                    </View>
                    <View
                      style={{
                        flexDirection: 'row',
                        flexWrap: 'wrap',
                        paddingBottom: 10,
                        justifyContent: 'center',
                      }}>
                      {[
                        {
                          libelle: 'Modifier',
                          action: () => {
                            goToDemanderDevisAssurance(devis);
                          },
                          // eslint-disable-next-line @typescript-eslint/no-require-imports
                          image: require('../../../../../ressources/images/Edit.png'),
                        },
                        {
                          libelle: 'Supprimer',
                          action: () => {
                            setModalData({
                              status: true,
                              title: 'Confirmation',
                              content:
                                'Etes-vous certain de vouloir supprimer cette Devis ?',
                              btn1: 'Supprimer',
                              btn2: 'Annuler',
                              handleBtn1: () =>
                                handleRemoveDevisDetails(devis.id),
                              handleBtn2: () =>
                                setModalData({...initModalData}),
                            });
                          },
                          // eslint-disable-next-line @typescript-eslint/no-require-imports
                          image: require('../../../../../ressources/images/close-1.png'),
                        },
                        {
                          libelle: 'Souscrire',
                          action: () => handlePostDevisDetails(devis, true),
                          // eslint-disable-next-line @typescript-eslint/no-require-imports
                          image: require('../../../../../ressources/images/Arrow-Right.png'),
                        },
                      ].map((element: any, index: number) => (
                        <ButtonItems
                          key={`detailContrat_${index}`}
                          image={element.image}
                          action={element.action}
                          libelle={element.libelle}
                          style={
                            Platform.OS === 'web' ? {height: 120} : undefined
                          }
                        />
                      ))}
                    </View>
                  </TouchableOpacity>
                );
              })
            : null}
        </PageContainer>
      )}
    </View>
  );
};

export const ListDevisAssuranceVoyage: any = connect(
  mapStateToProps,
  mapDispatchToProps,
)(MesDevisFC);
